<template>
  <div style="position: relative">
    <PageHeading title="Perfil" />
    <v-container class="mt-10" fluid>
      <v-form v-model="valid">
        <v-row justify="center" class="mb-10">
          <v-avatar color="#C4C4C4" size="100" @click="launchFilePicker()">
            <v-icon v-if="!user.photoURL && !avatarURL">mdi-plus</v-icon>
            <v-img v-if="loggedIn && (user.photoURL || avatarURL)" :src="avatarURL || user.photoURL"/>
            <input
              type="file"
              ref="file"
              accept=".jpg,.jpeg,.png"
              @change="onFileChange($event.target.files)"
              style="display:none">
          </v-avatar>
        </v-row>
        <v-text-field
          class="mt-2"
          label="Nome"
          v-model="name"
          :rules="nameRules"
          :append-icon="nameEnabled ? undefined : 'mdi-pencil'"
          :readonly="!nameEnabled"
          @click:append="nameEnabled = true"
          :filled="nameEnabled"
          validate-on-blur
          required
          :loading="loading"
        />
        <v-text-field
          class="mt-2"
          label="Email"
          v-model="email"
          :rules="emailRules"
          :append-icon="emailEnabled ? undefined : 'mdi-pencil'"
          :readonly="!emailEnabled"
          @click:append="emailEnabled = true"
          :filled="emailEnabled"
          validate-on-blur
          required
          :loading="loading"
        />
      </v-form>
      <v-row>
        <v-btn 
          color="error" 
          @click="signOut()" 
          :disabled="editEnabled"
        >Desconectar</v-btn>
      </v-row>
    </v-container>
    <v-fab-transition>
      <v-btn
        class="mx-2"
        v-show="editEnabled"
        :disabled="loading"
        fab
        fixed
        bottom
        left
        dark
        color="#802C12"
        @click="resetDefaults()"
      >
        <v-icon dark>mdi-close</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-fab-transition>
      <v-btn
        class="mx-2"
        v-show="editEnabled"
        :disabled="loading"
        fab
        fixed
        bottom
        right
        dark
        color="#802C12"
        @click="updateUser()"
      >
        <v-icon dark>mdi-check</v-icon>
      </v-btn>
    </v-fab-transition>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";

import PageHeading from "@/components/PageHeading.vue";

export default {
  name: "Profile",
  components: {
    PageHeading
  },
  data() {
    return {
      loading: false,
      error: "",
      valid: false,
      avatarImage: null,
      avatarURL: null,
      nameEnabled: false,
      emailEnabled: false,
      avatarEnabled: false,
      name: "Desconhecido",
      email: "",
      nameRules: [
        v => !!v || "Nome é necessário."
      ],
      emailRules: [
        v => !!v || "Email é necessário.",
        v => /.+@.+/.test(v) || "Email precisa ser válido."
      ],
      fileRules: [
        v => !v || v.size < 2000000 || "Arquivo muito grande. Máximo 2MB"
      ]
    };
  },
  mounted() {
    if (this.loggedIn) {
      this.$store.dispatch("user/cache").then(() => {
        this.name = this.user.displayName;
        this.email = this.user.email;
      });
    }
  },
  watch: {
    loggedIn(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.name = this.user.displayName;
        this.email = this.user.email;
      }
    }
  },
  computed: {
    editEnabled() { return this.nameEnabled || this.emailEnabled || this.avatarEnabled; },
    ...mapGetters([
      "loggedIn",
      "user",
      "user_id",
      "auth"
    ]),
    ...mapState([
      "storage"
    ])
  },
  methods: {
    async updateUser() {
      this.loading = true;
      await this.$store.dispatch("user/update", {
        name: (this.nameEnabled && this.name) || null,
        email: (this.emailEnabled && this.email) || null,
        avatarImage: (this.avatarEnabled && this.avatarImage) || null
      });
      this.resetDefaults();
      this.loading = false;
    },
    resetDefaults() {
      this.nameEnabled = false;
      this.emailEnabled = false;
      this.avatarEnabled = false;
      this.avatarURL = this.user.photoURL;
    },
    async signOut() {
      this.loading = true;
      await this.$store.dispatch("logout");
      await this.$router.push({
        name: "Login"
      });
    },
    launchFilePicker() {
      this.$refs.file.click();
    },
    onFileChange(files) {
      this.avatarEnabled = true;
      this.avatarImage = files[0];
      this.avatarURL = URL.createObjectURL(this.avatarImage);
    }
  }
};
</script>
<style lang="scss">
.login-subheader {
  color: #CE3E17 !important;
  font-size: 1.2em !important;
  height: auto;
}
</style>